module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('Navbar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bca899f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/Loans.vue
// module id = 997
// module chunks = 0